import { useNavigate } from '@tanstack/react-router'
import { Button } from '@/shared/components/ui/button'
import { CHAT_COPY } from '@/entities/chat'

export function ChatAccessEnded() {
  const navigate = useNavigate()
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 px-6 text-center">
      <p className="text-[13px] text-ink-2">{CHAT_COPY.accessEnded}</p>
      <Button variant="outline" size="sm" onClick={() => navigate({ to: '/' })}>
        {CHAT_COPY.accessEndedAction}
      </Button>
    </div>
  )
}
